"use client";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { AttendanceStatus } from "@prisma/client";
import { useState } from "react";
import { LuChevronRight, LuChevronDown, LuChevronUp } from "react-icons/lu";
import { If } from "~/components/v3/Conditional";
import { UserAvatar } from "~/components/v4/shadcn/UserAvatar";

type InvitedAttendeesProps = {
    invitedAttendees: {
        status: AttendanceStatus;
        user: {
            name?: string | null;
            email?: string | null;
            image?: string | null;
        };
    }[];
};
const InvitedAttendees = ({ invitedAttendees }: InvitedAttendeesProps) => {
    const [ref] = useAutoAnimate();
    const [isCollapsed, setIsCollapsed] = useState(true);

    return (
        <div className="flex-col gap-4" ref={ref}>
            <p className="text-sm font-medium">
                {invitedAttendees.length} Invited
            </p>
            <div className="flex items-center gap-2">
                <If condition={isCollapsed}>
                    <div className="flex w-max -space-x-5">
                        {invitedAttendees.slice(0, 3).map((attendee) => (
                            <div
                                key={attendee.user.email}
                                className="flex items-center gap-2"
                            >
                                <UserAvatar user={attendee.user} />
                            </div>
                        ))}
                    </div>
                </If>
                <button
                    className="flex w-full justify-between text-center text-sm"
                    onClick={() => setIsCollapsed(!isCollapsed)}
                >
                    {isCollapsed ? (
                        <>
                            <p>+{invitedAttendees.length - 3} more</p>
                            <LuChevronRight className="h-6 w-6" />
                        </>
                    ) : (
                        <LuChevronUp className="ml-auto h-6 w-6" />
                    )}
                </button>
            </div>
            {!isCollapsed && (
                <div className="max-h-[500px] space-y-2 overflow-y-auto pb-10">
                    {invitedAttendees.map((invite) => (
                        <div
                            key={invite.user.email}
                            className="flex items-center justify-between rounded-lg p-3"
                        >
                            <div className="flex items-center gap-2">
                                <UserAvatar user={invite.user} />

                                <div className="flex flex-col">
                                    {invite.user.name && (
                                        <div className="text-sm text-white">
                                            {invite.user.name}
                                        </div>
                                    )}
                                    <div className="text-sm text-gray-500">
                                        {invite.user.email}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default InvitedAttendees;
